var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"hide-label":_vm.icon,"label":_vm.$t('va.actions.dissociate'),"icon":"mdi-link-off","color":_vm.color || 'red',"text":""},on:{"click":_vm.onDissociate}})}
var staticRenderFns = []

export { render, staticRenderFns }